export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validateSerialNumber(serialNumber: string): boolean {
  return /^\d{8}$/.test(serialNumber);
}
